import { Choice } from '../type/choice';

type Params = {
  item: Choice;
  onClick: (choice: Choice) => void;
};

export function useViewModel(params: Params) {
  const clickHandler = () => {
    params.onClick(params.item);
  };

  return {
    clickHandler,
  };
}
